/* ==========================================================================
   SURGE PEPT — zwevende WhatsApp-knop
   Hoort bij snippets/whatsapp-button.liquid en assets/whatsapp-button.css.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-spwa]');
  if (!root) return;

  var toggle = root.querySelector('[data-spwa-toggle]');
  var panel = root.querySelector('[data-spwa-panel]');
  var cta = root.querySelector('[data-spwa-cta]');
  if (!toggle || !panel) return;

  /* Beide tijden gerekend vanaf het laden van de pagina: het label schuift
     na 2 seconden in en verdwijnt op 6 seconden, dus het staat 4 seconden
     in beeld. Klikken op de knop haalt het meteen weg. */
  var TEASER_IN_MS = 2000;
  var TEASER_OUT_MS = 6000;

  var teaserTimers = [];

  function clearTeaser() {
    root.classList.remove('is-teasing');
    while (teaserTimers.length) clearTimeout(teaserTimers.pop());
  }

  function open() {
    root.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', toggle.getAttribute('data-label-close'));
    clearTeaser();
    document.addEventListener('click', onOutsideClick, true);
    document.addEventListener('keydown', onKeydown);
  }

  function close(returnFocus) {
    root.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', toggle.getAttribute('data-label-open'));
    document.removeEventListener('click', onOutsideClick, true);
    document.removeEventListener('keydown', onKeydown);
    if (returnFocus) toggle.focus();
  }

  function onOutsideClick(ev) {
    if (!root.contains(ev.target)) close(false);
  }

  function onKeydown(ev) {
    if (ev.key === 'Escape' || ev.key === 'Esc') {
      ev.stopPropagation();
      close(true);
    }
  }

  toggle.addEventListener('click', function () {
    if (root.classList.contains('is-open')) close(false);
    else open();
  });

  /* Na het openen van WhatsApp heeft het paneel geen functie meer. */
  if (cta) cta.addEventListener('click', function () { close(false); });

  /* Het label alleen tonen wanneer er ruimte voor is. De grens komt overeen
     met de media query in whatsapp-button.css. */
  if (window.matchMedia && window.matchMedia('(min-width: 520px)').matches) {
    teaserTimers.push(setTimeout(function () {
      if (!root.classList.contains('is-open')) root.classList.add('is-teasing');
    }, TEASER_IN_MS));

    teaserTimers.push(setTimeout(function () {
      root.classList.remove('is-teasing');
    }, TEASER_OUT_MS));
  }
})();
